
export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function () {
      this.$router.push({ path: '/home' })
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function () {
      // this.$store.state.message = 'Logout successfully';
      localStorage.clear()
      this.$store.dispatch('account/logout')
      this.$router.push({ path: '/login' })
    }
  },
  {
    name: 'ORDER_SUCCESS',
    callback: function (data) {
      this.$store.dispatch('alert/success', 'Order Created Successfully', { root: true })
      this.$router.push({ path: '/tokensms/order/success/'+data.id })
    }
  },
  {
    name: 'APP_INFO',
    callback: function (msg) {
      console.log(msg);
      this.$store.dispatch('alert/success', 'Pesan Terkirim', { root: true })
    }
  },

  {
    name: 'APP_INFO_ERROR',
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      }
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function () {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function () {
      this.$router.push({ path: '/login' })
      this.$message.error('Token has expired')
    }
  },
  {
    name: 'APP_CHANNGE_PASSWORD',
    callback: function () {
      this.$router.push('/changepassword')
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg)
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      }
      this.$router.push({ path: '/login' })
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg)
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg)
    }
  },
  {
    name: 'APP_DRAWER_TOGGLED',
    callback: function () {
      this.$store.dispatch('account/stateDrawer')
    }
  }
]
